// imports
import { Box, styled } from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';

const BannerMessage = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  backgroundColor: '#fcf4d4',
  borderRadius: '4px',
  padding: '10px 10px 10px 5px',
  fontSize: '1rem',
  fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
  gap: theme.spacing(1),
  borderLeft: '5px solid orange',
  width: 'calc(100% - 10px)',
  boxSizing: 'border-box',
}));

interface ZoomDisabledBannerProps {
  minZoom: number;
}

/**
 * ZoomDisabledBanner
 *
 * Informational banner displayed inside an AdditionalLayer when the current
 * map zoom is below the layer's minZoom threshold.
 * Styled consistently with ViewDataBanner's BannerMessage. No close button.
 */
export default function ZoomDisabledBanner({ minZoom }: ZoomDisabledBannerProps) {
  return (
    <BannerMessage role="status" data-testid="zoom-disabled-banner">
      <InfoOutlineIcon sx={{ fontSize: '1.5rem', flexShrink: 0 }} />
      <span>Visible at zoom level {minZoom} or greater</span>
    </BannerMessage>
  );
}
